// extracted by mini-css-extract-plugin
export var contentBody = "_3y-9";
export var headerImage = "_3y-2";
export var imageButton = "_3y-7";
export var imageButtonIcon = "_3y-8";
export var imageHeader = "_3y-4";
export var imageHeaderText = "_3y-5";
export var imageOverlay = "_3y-3";
export var imageTitle = "_3y-6";
export var imageWrapper = "_3y-1";
export var taskList = "_3y-a";
export var widget = "_3y-0";